import Vue from 'vue'

// 跨组件事件总线（瞬态事件，如协议弹框联动）
const eventBus = new Vue()

export default eventBus
